import Image from 'next/legacy/image';

const LoadingSpinner = ({
  width = 80,
  height = 80,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <div className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 bg-transparent">
      <Image
        src="/images/icons/loading-anim-5.svg"
        priority
        width={width}
        height={height}
        alt="loading"
      />
    </div>
  );
};

export default LoadingSpinner;
